import React from 'react';
import { mapDispatchToProps as menuActions } from 'actions/menu';
import { mapDispatchToProps as authActions } from 'actions/auth';
import { connect } from 'react-redux';
import './sidenav.scss';
import SideNavItem from './SideNavItem';
import { USER_ROLES, isUserAuthorized } from 'utils';

const mapStateToProps = function ({ menu, auth }) {
  return {
    menuItems: menu.menuItems,
    isOpen: menu.isOpen,
    loggedInUser: auth.loggedInUser && JSON.parse(JSON.stringify(auth.loggedInUser)),
  };
};

class SideNav extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
    };
  }

  searchTxt(e) {
    this.setState({ searchTerm: e.target.value });
  }

  logout = async () => {
    await this.props.logout();
  };

  getMenuItems = () => {
    const { searchTerm } = this.state;
    const { loggedInUser: user } = this.props;

    return this.props.menuItems.filter((val => {
      if (searchTerm === '') {
        return val;
      } else if (val.title.toLowerCase().includes(searchTerm.toLowerCase())) {
        return val;
      }
    })).map(menuItem => {
      if (!isUserAuthorized(user.roles, menuItem.roles)) return null;
      return <SideNavItem closeMenu={this.props.closeMenu} menuItem={menuItem} key={menuItem.title} />;
    });
  };

  getLogoutMenuItem = () => {
    const menuItem = {
      iconClass: 'fa-sign-out',
      title: 'Logout',
      customClass: 'logout border-none',
      url: '/',
      onClick: this.logout,
    };
    return (
      <SideNavItem closeMenu={this.props.closeMenu} menuItem={menuItem} />
    );
  };

  toggleMenu = () => {
    if (this.props.isOpen) {
      this.props.closeMenu();
    } else {
      this.props.openMenu();
    }
  };
  renderMenu = () => {
    if (this.props.loggedInUser) {
      return (
        <>
          <div id={'sidenav-toggle'} className={`toggle-button d-flex justify-content-center align-items-center position-absolute ${this.props.isOpen ? 'open' : ''}`} onClick={() => this.toggleMenu()}>
            <i className="fa fa-bars"></i>
          </div>
          <div id={'sidenav'} className={`sidenav  custom-scrollbar position-fixed text-center ${this.props.isOpen ? 'open' : ''}`}>
            <p className="logo mb-4 mt-4">
              <img src={require('../../assets/logo.svg')} alt="PRoduce!" />
            </p>
            <div className="menu">
              <input style={{ width: '260px', height: '40px', fontSize: '14px', lineHeight: '18px', color: '#161616' }} onChange={this.searchTxt.bind(this)} className='form-control mx-auto my-2' placeholder='Search Your Page' type="text" />
              {this.getMenuItems()}
            </div>
            <div className="footer">
              <div className="profile text-left m-auto d-flex align-items-center">
                <div className="avatar">
                  <img src={require('../../assets/avatar.png')} alt="user-avatar" />
                </div>
                <div className="user-info">
                  <div className="username">{this.props.loggedInUser.full_name}</div>
                  <div className="user-email">{this.props.loggedInUser.email}</div>
                </div>
              </div>
              <div className="logout">
                {this.getLogoutMenuItem()}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return <></>;
    }
  };

  render(): any {
    return (
      <>{this.renderMenu()}</>
    );
  }
}

const SideNavWrapper = connect(mapStateToProps, { ...menuActions, ...authActions })(SideNav);
export { SideNavWrapper as SideNav };
